import { convertFieldsToSearch } from 'services/helper';
import BaseApi from '../BaseApi';
import { UserApiConverter } from './UserApiConverter';
import parseNumberFromString from 'shared/helpers/parseNumberFromString';

class UserApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/agent_admin`;
    this.converter = new UserApiConverter();
  }

  createUser = requestBody => this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/user/`, requestBody);

  depositOrWithdrawal = ({ id, operation, amount, bonusAmount, bonusPercentAmount, isBonus }) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/user/${id}/payment/`, {
      operation,
      amount: parseNumberFromString(amount),
      is_bonus: isBonus || undefined,
      percent_amount: isBonus && +bonusPercentAmount ? +bonusPercentAmount : undefined,
      bonus_amount: isBonus && bonusAmount ? parseNumberFromString(bonusAmount) : undefined,
    });

  getUsersList = (filters, selfId) => {
    const { userId, isBanned, isDirectStructure, ...data } = filters;
    return this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/user/${convertFieldsToSearch({
        ...data,
        user_id: userId ?? null,
        is_banned: isBanned ?? null,
        is_direct_structure: isDirectStructure ?? null,
      })}`,
      null,
      null,
      data => this.converter.convertUsersList(data, filters),
      { role: data.role },
    );
  };
  changeBanState = (id, value) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/change_attribute`, {
      operation: 'change_ban',
      target_id: id,
      is_banned: value,
    });

  changeUserBalance = (id, amount, isOutcome) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/change_attribute`, {
      operation: 'change_balance',
      target_id: +id,
      amount: +amount,
      is_outcome: isOutcome,
    });

  resetPassword = (id, new_password) =>
    this.sendQuery(
      this.queryTypes.POST,
      `${this.baseUrl}/change_attribute`,
      {
        operation: 'change_password',
        target_id: id,
        new_password: new_password,
      },
      null,
      this.converter.convertNewPassword,
    );

  changeUserInfo = ({ data, id }) => {
    return this.sendQuery(this.queryTypes.PATCH, `${this.baseUrl}/user/${id}/`, data);
  };

  getBannedProviders = ({ id }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/user/${id}/blocklist/`,
      null,
      null,
      this.converter.convertBannedProviders,
    );

  setBannedProviders = ({ data }) => {
    return this.sendQuery(
      this.queryTypes.POST,
      `${this.baseUrl}/user/${data.id}/blocklist/`,
      {
        providers: data.providers,
        action: data.action,
        category: data.category,
        is_full_branch: data.isFullBranch,
        semi_auto_withdrawal_enabled: data.semiAutoWithdrawalEnabled,
        is_visible_feedback_link: data.isVisibleFeedbackLink,
        are_promotions_available: data.arePromotionsAvailable,
      },
      null,
      this.converter.convertBannedProvidersSet,
    );
  };

  getUserInfo = ({ id }) =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/user/${id}/`, null, null, this.converter.convertUserInfo);

  searchUsers = ({ username, is_direct_structure = false }) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/user/search/`,
      { username, is_direct_structure },
      undefined,
      d => d.data,
    );

  getProfileInfo = () =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/banks/`, null, null, this.converter.convertProfileInfo);

  getSettingLimitsInfo = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/payment/settings`,
      null,
      null,
      this.converter.convertSettingLimitsInfo,
    );

  setSettingLimits = data =>
    this.sendQuery(
      this.queryTypes.POST,
      `${this.baseUrl}/payment/settings`,
      { minimum_deposit: data.minimumDeposit, minimum_withdrawal: data.minimumWithdrawal },
      null,
    );
}

export default UserApi;
